/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AlertAckRouteImport } from './routes/alert-ack'
import { Route as AppRouteImport } from './routes/app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppLayoutRouteImport } from './routes/app/_layout'
import { Route as AppAlertsRouteImport } from './routes/app/alerts'
import { Route as AppHomeRouteImport } from './routes/app/home'
import { Route as AppLocationGateRouteImport } from './routes/app/location-gate'
import { Route as AppMapRouteImport } from './routes/app/map'
import { Route as AppPhoneGateRouteImport } from './routes/app/phone-gate'
import { Route as AppPrefsRouteImport } from './routes/app/prefs'
import { Route as AppReportRouteImport } from './routes/app/report'
import { Route as AppSearchRouteImport } from './routes/app/search'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingAlertsRouteImport } from './routes/onboarding/alerts'
import { Route as OnboardingCarouselRouteImport } from './routes/onboarding/carousel'
import { Route as OnboardingConsentRouteImport } from './routes/onboarding/consent'
import { Route as OnboardingContactsRouteImport } from './routes/onboarding/contacts'
import { Route as OnboardingDoneRouteImport } from './routes/onboarding/done'
import { Route as OnboardingEnableRouteImport } from './routes/onboarding/enable'
import { Route as OnboardingLocationsRouteImport } from './routes/onboarding/locations'
import { Route as OnboardingPersonaRouteImport } from './routes/onboarding/persona'
import { Route as OnboardingPersonaSetupRouteImport } from './routes/onboarding/persona-setup'
import { Route as OnboardingSignupRouteImport } from './routes/onboarding/signup'
import { Route as OnboardingVerifyRouteImport } from './routes/onboarding/verify'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertAckRoute = AlertAckRouteImport.update({
  id: '/alert-ack',
  path: '/alert-ack',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppLayoutRoute = AppLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppLocationGateRoute = AppLocationGateRouteImport.update({
  id: '/location-gate',
  path: '/location-gate',
  getParentRoute: () => AppRoute,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppRoute,
} as any)
const AppPhoneGateRoute = AppPhoneGateRouteImport.update({
  id: '/phone-gate',
  path: '/phone-gate',
  getParentRoute: () => AppRoute,
} as any)
const AppPrefsRoute = AppPrefsRouteImport.update({
  id: '/prefs',
  path: '/prefs',
  getParentRoute: () => AppRoute,
} as any)
const AppReportRoute = AppReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingAlertsRoute = OnboardingAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCarouselRoute = OnboardingCarouselRouteImport.update({
  id: '/carousel',
  path: '/carousel',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingConsentRoute = OnboardingConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingContactsRoute = OnboardingContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingDoneRoute = OnboardingDoneRouteImport.update({
  id: '/done',
  path: '/done',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingEnableRoute = OnboardingEnableRouteImport.update({
  id: '/enable',
  path: '/enable',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingLocationsRoute = OnboardingLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingPersonaRoute = OnboardingPersonaRouteImport.update({
  id: '/persona',
  path: '/persona',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingPersonaSetupRoute = OnboardingPersonaSetupRouteImport.update({
  id: '/persona-setup',
  path: '/persona-setup',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSignupRoute = OnboardingSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingVerifyRoute = OnboardingVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alert-ack': typeof AlertAckRoute
  '/app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin/login': typeof AdminLoginRoute
  '/app/alerts': typeof AppAlertsRoute
  '/app/home': typeof AppHomeRoute
  '/app/location-gate': typeof AppLocationGateRoute
  '/app/map': typeof AppMapRoute
  '/app/phone-gate': typeof AppPhoneGateRoute
  '/app/prefs': typeof AppPrefsRoute
  '/app/report': typeof AppReportRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/onboarding/alerts': typeof OnboardingAlertsRoute
  '/onboarding/carousel': typeof OnboardingCarouselRoute
  '/onboarding/consent': typeof OnboardingConsentRoute
  '/onboarding/contacts': typeof OnboardingContactsRoute
  '/onboarding/done': typeof OnboardingDoneRoute
  '/onboarding/enable': typeof OnboardingEnableRoute
  '/onboarding/locations': typeof OnboardingLocationsRoute
  '/onboarding/persona': typeof OnboardingPersonaRoute
  '/onboarding/persona-setup': typeof OnboardingPersonaSetupRoute
  '/onboarding/signup': typeof OnboardingSignupRoute
  '/onboarding/verify': typeof OnboardingVerifyRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alert-ack': typeof AlertAckRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin/login': typeof AdminLoginRoute
  '/app': typeof AppIndexRoute
  '/app/alerts': typeof AppAlertsRoute
  '/app/home': typeof AppHomeRoute
  '/app/location-gate': typeof AppLocationGateRoute
  '/app/map': typeof AppMapRoute
  '/app/phone-gate': typeof AppPhoneGateRoute
  '/app/prefs': typeof AppPrefsRoute
  '/app/report': typeof AppReportRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/onboarding/alerts': typeof OnboardingAlertsRoute
  '/onboarding/carousel': typeof OnboardingCarouselRoute
  '/onboarding/consent': typeof OnboardingConsentRoute
  '/onboarding/contacts': typeof OnboardingContactsRoute
  '/onboarding/done': typeof OnboardingDoneRoute
  '/onboarding/enable': typeof OnboardingEnableRoute
  '/onboarding/locations': typeof OnboardingLocationsRoute
  '/onboarding/persona': typeof OnboardingPersonaRoute
  '/onboarding/persona-setup': typeof OnboardingPersonaSetupRoute
  '/onboarding/signup': typeof OnboardingSignupRoute
  '/onboarding/verify': typeof OnboardingVerifyRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/admin': typeof AdminIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alert-ack': typeof AlertAckRoute
  '/app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin/login': typeof AdminLoginRoute
  '/app/_layout': typeof AppLayoutRoute
  '/app/alerts': typeof AppAlertsRoute
  '/app/home': typeof AppHomeRoute
  '/app/location-gate': typeof AppLocationGateRoute
  '/app/map': typeof AppMapRoute
  '/app/phone-gate': typeof AppPhoneGateRoute
  '/app/prefs': typeof AppPrefsRoute
  '/app/report': typeof AppReportRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/onboarding/alerts': typeof OnboardingAlertsRoute
  '/onboarding/carousel': typeof OnboardingCarouselRoute
  '/onboarding/consent': typeof OnboardingConsentRoute
  '/onboarding/contacts': typeof OnboardingContactsRoute
  '/onboarding/done': typeof OnboardingDoneRoute
  '/onboarding/enable': typeof OnboardingEnableRoute
  '/onboarding/locations': typeof OnboardingLocationsRoute
  '/onboarding/persona': typeof OnboardingPersonaRoute
  '/onboarding/persona-setup': typeof OnboardingPersonaSetupRoute
  '/onboarding/signup': typeof OnboardingSignupRoute
  '/onboarding/verify': typeof OnboardingVerifyRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alert-ack'
    | '/app'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/admin/login'
    | '/app/alerts'
    | '/app/home'
    | '/app/location-gate'
    | '/app/map'
    | '/app/phone-gate'
    | '/app/prefs'
    | '/app/report'
    | '/app/search'
    | '/app/settings'
    | '/auth/callback'
    | '/onboarding/alerts'
    | '/onboarding/carousel'
    | '/onboarding/consent'
    | '/onboarding/contacts'
    | '/onboarding/done'
    | '/onboarding/enable'
    | '/onboarding/locations'
    | '/onboarding/persona'
    | '/onboarding/persona-setup'
    | '/onboarding/signup'
    | '/onboarding/verify'
    | '/onboarding/welcome'
    | '/admin/'
    | '/app/'
    | '/onboarding/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alert-ack'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/admin/login'
    | '/app'
    | '/app/alerts'
    | '/app/home'
    | '/app/location-gate'
    | '/app/map'
    | '/app/phone-gate'
    | '/app/prefs'
    | '/app/report'
    | '/app/search'
    | '/app/settings'
    | '/auth/callback'
    | '/onboarding/alerts'
    | '/onboarding/carousel'
    | '/onboarding/consent'
    | '/onboarding/contacts'
    | '/onboarding/done'
    | '/onboarding/enable'
    | '/onboarding/locations'
    | '/onboarding/persona'
    | '/onboarding/persona-setup'
    | '/onboarding/signup'
    | '/onboarding/verify'
    | '/onboarding/welcome'
    | '/admin'
    | '/onboarding'
  id:
    | '__root__'
    | '/'
    | '/alert-ack'
    | '/app'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/admin/login'
    | '/app/_layout'
    | '/app/alerts'
    | '/app/home'
    | '/app/location-gate'
    | '/app/map'
    | '/app/phone-gate'
    | '/app/prefs'
    | '/app/report'
    | '/app/search'
    | '/app/settings'
    | '/auth/callback'
    | '/onboarding/alerts'
    | '/onboarding/carousel'
    | '/onboarding/consent'
    | '/onboarding/contacts'
    | '/onboarding/done'
    | '/onboarding/enable'
    | '/onboarding/locations'
    | '/onboarding/persona'
    | '/onboarding/persona-setup'
    | '/onboarding/signup'
    | '/onboarding/verify'
    | '/onboarding/welcome'
    | '/admin/'
    | '/app/'
    | '/onboarding/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertAckRoute: typeof AlertAckRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alert-ack': {
      id: '/alert-ack'
      path: '/alert-ack'
      fullPath: '/alert-ack'
      preLoaderRoute: typeof AlertAckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_layout': {
      id: '/app/_layout'
      path: ''
      fullPath: '/app'
      preLoaderRoute: typeof AppLayoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/alerts': {
      id: '/app/alerts'
      path: '/alerts'
      fullPath: '/app/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/home': {
      id: '/app/home'
      path: '/home'
      fullPath: '/app/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/location-gate': {
      id: '/app/location-gate'
      path: '/location-gate'
      fullPath: '/app/location-gate'
      preLoaderRoute: typeof AppLocationGateRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/map': {
      id: '/app/map'
      path: '/map'
      fullPath: '/app/map'
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/phone-gate': {
      id: '/app/phone-gate'
      path: '/phone-gate'
      fullPath: '/app/phone-gate'
      preLoaderRoute: typeof AppPhoneGateRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/prefs': {
      id: '/app/prefs'
      path: '/prefs'
      fullPath: '/app/prefs'
      preLoaderRoute: typeof AppPrefsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/report': {
      id: '/app/report'
      path: '/report'
      fullPath: '/app/report'
      preLoaderRoute: typeof AppReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/search': {
      id: '/app/search'
      path: '/search'
      fullPath: '/app/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/alerts': {
      id: '/onboarding/alerts'
      path: '/alerts'
      fullPath: '/onboarding/alerts'
      preLoaderRoute: typeof OnboardingAlertsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/carousel': {
      id: '/onboarding/carousel'
      path: '/carousel'
      fullPath: '/onboarding/carousel'
      preLoaderRoute: typeof OnboardingCarouselRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/consent': {
      id: '/onboarding/consent'
      path: '/consent'
      fullPath: '/onboarding/consent'
      preLoaderRoute: typeof OnboardingConsentRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/contacts': {
      id: '/onboarding/contacts'
      path: '/contacts'
      fullPath: '/onboarding/contacts'
      preLoaderRoute: typeof OnboardingContactsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/done': {
      id: '/onboarding/done'
      path: '/done'
      fullPath: '/onboarding/done'
      preLoaderRoute: typeof OnboardingDoneRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/enable': {
      id: '/onboarding/enable'
      path: '/enable'
      fullPath: '/onboarding/enable'
      preLoaderRoute: typeof OnboardingEnableRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/locations': {
      id: '/onboarding/locations'
      path: '/locations'
      fullPath: '/onboarding/locations'
      preLoaderRoute: typeof OnboardingLocationsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/persona': {
      id: '/onboarding/persona'
      path: '/persona'
      fullPath: '/onboarding/persona'
      preLoaderRoute: typeof OnboardingPersonaRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/persona-setup': {
      id: '/onboarding/persona-setup'
      path: '/persona-setup'
      fullPath: '/onboarding/persona-setup'
      preLoaderRoute: typeof OnboardingPersonaSetupRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup': {
      id: '/onboarding/signup'
      path: '/signup'
      fullPath: '/onboarding/signup'
      preLoaderRoute: typeof OnboardingSignupRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/verify': {
      id: '/onboarding/verify'
      path: '/verify'
      fullPath: '/onboarding/verify'
      preLoaderRoute: typeof OnboardingVerifyRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
  }
}

interface AppRouteChildren {
  AppLayoutRoute: typeof AppLayoutRoute
  AppAlertsRoute: typeof AppAlertsRoute
  AppHomeRoute: typeof AppHomeRoute
  AppLocationGateRoute: typeof AppLocationGateRoute
  AppMapRoute: typeof AppMapRoute
  AppPhoneGateRoute: typeof AppPhoneGateRoute
  AppPrefsRoute: typeof AppPrefsRoute
  AppReportRoute: typeof AppReportRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLayoutRoute: AppLayoutRoute,
  AppAlertsRoute: AppAlertsRoute,
  AppHomeRoute: AppHomeRoute,
  AppLocationGateRoute: AppLocationGateRoute,
  AppMapRoute: AppMapRoute,
  AppPhoneGateRoute: AppPhoneGateRoute,
  AppPrefsRoute: AppPrefsRoute,
  AppReportRoute: AppReportRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface OnboardingRouteChildren {
  OnboardingAlertsRoute: typeof OnboardingAlertsRoute
  OnboardingCarouselRoute: typeof OnboardingCarouselRoute
  OnboardingConsentRoute: typeof OnboardingConsentRoute
  OnboardingContactsRoute: typeof OnboardingContactsRoute
  OnboardingDoneRoute: typeof OnboardingDoneRoute
  OnboardingEnableRoute: typeof OnboardingEnableRoute
  OnboardingLocationsRoute: typeof OnboardingLocationsRoute
  OnboardingPersonaRoute: typeof OnboardingPersonaRoute
  OnboardingPersonaSetupRoute: typeof OnboardingPersonaSetupRoute
  OnboardingSignupRoute: typeof OnboardingSignupRoute
  OnboardingVerifyRoute: typeof OnboardingVerifyRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingAlertsRoute: OnboardingAlertsRoute,
  OnboardingCarouselRoute: OnboardingCarouselRoute,
  OnboardingConsentRoute: OnboardingConsentRoute,
  OnboardingContactsRoute: OnboardingContactsRoute,
  OnboardingDoneRoute: OnboardingDoneRoute,
  OnboardingEnableRoute: OnboardingEnableRoute,
  OnboardingLocationsRoute: OnboardingLocationsRoute,
  OnboardingPersonaRoute: OnboardingPersonaRoute,
  OnboardingPersonaSetupRoute: OnboardingPersonaSetupRoute,
  OnboardingSignupRoute: OnboardingSignupRoute,
  OnboardingVerifyRoute: OnboardingVerifyRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertAckRoute: AlertAckRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  AdminLoginRoute: AdminLoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
